import { parsePayPeriod } from "./payPeriods";
import { parseSalesCents } from "./shootSalesModel";
export const PERIOD_EXTRAS_ID="pay-period-extras";
export function validatePeriodExtras(entries) {
  const ids=new Set();
  return entries.map(entry=>{
    const period=parsePayPeriod(entry.payPeriod);
    if(!entry.id || ids.has(entry.id))throw new Error("Each extra payment needs a unique ID.");
    ids.add(entry.id);
    if(!period || !String(entry.nickname || "").trim() || !String(entry.label || "").trim())throw new Error("Choose a pay period, photographer, and label for every extra payment.");
    if(!Number.isSafeInteger(entry.amountCents) || entry.amountCents<=0)throw new Error("Additional pay must be greater than $0.");
    if(entry.label.length>160 || String(entry.notes || "").length>500)throw new Error("Use a label under 160 characters and notes under 500 characters.");
    return {...entry,payPeriod:period.start,label:entry.label.trim(),notes:String(entry.notes || "").trim()};
  });
}
export function makePeriodExtras(names,period,label,amount,notes,idFactory) {
  const amountCents=parseSalesCents(amount);
  if(!names.length)throw new Error("Select at least one photographer.");
  return validatePeriodExtras([...new Set(names)].map(nickname=>({id:idFactory(),nickname,payPeriod:period,label,amountCents,notes})));
}
export function periodExtrasCSV(entries) {
  const escape=value=>'"'+String(value ?? "").replace(/"/g,'""')+'"';
  return [["Pay period","Check date","Photographer","Additional pay label","Notes","Amount"],...validatePeriodExtras(entries).map(entry=>{
    const period=parsePayPeriod(entry.payPeriod);
    return [period.label,period.checkLabel,entry.nickname,entry.label,entry.notes,(entry.amountCents/100).toFixed(2)];
  })].map(row=>row.map(escape).join(",")).join("\r\n");
}
